/**
 * Centralized brand name configuration.
 *
 * Change the brand name in ONE place:
 *   - For local dev: edit REACT_APP_BRAND_NAME in frontend/.env
 *   - For production builds: change BRAND_NAME in frontend/Makefile
 *
 * Examples:
 *   BRAND_NAME := HelpPetAI   →  all UI text says "HelpPetAI"
 *   BRAND_NAME := HelpPet     →  all UI text says "HelpPet"
 */
export const APP_NAME = process.env.REACT_APP_BRAND_NAME || 'HelpPet';
